module.exports = __webpack_public_path__ + "img/logo-linkomweb.png?c4b2bf35f80bc497895f18cf2e54c97f";